module.exports = __webpack_public_path__ + "static/media/meet.3f9e073a.png";